import React, { useEffect, useState } from 'react';
import Switch from "react-switch";


const SelectCuota = (props) => {
    const [check, setCheck] = useState(true);

    useEffect(() => {
        props.addCuota(props.cuota)
    }, []);

    let cambiar = () => {
        setCheck(!check);
        (check === false) ? props.addCuota(props.cuota) : props.delCuota(props.cuota);   
    }

    return(
        <div title = "Agregar o quitar el cobro de esta cuota"><Switch height={12} width={24} onChange={cambiar} checked={check} /></div>
    )
}

export default SelectCuota


// WEBPACK FOOTER //
// ./src/views/Administracion/CobranzasContent/SelectCuota.jsx